import { type FC } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

interface StationDetailsLoaderProps {
  departureCount?: number;
}

const StationDetailsLoader: FC<StationDetailsLoaderProps> = ({ departureCount = 4 }) => {
  const loadingItems = Array(departureCount).fill(1);

  return (
    <div className="flex flex-col gap-4 pt-4 px-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3 grow">
          <Skeleton className="size-10 rounded-lg" />
          <Skeleton className="h-6 w-full" />
        </div>
        <Skeleton className="size-9 rounded-lg ml-5" />
      </div>
      <Skeleton className="h-9 w-full" />
      <div className="shrink-0 border-b -mx-4 px-4">
        <div className="flex items-center h-9 gap-4">
          <Skeleton className="w-24 h-3.5 rounded-sm" />
          <Skeleton className="w-28 h-3.5 rounded-sm" />
          <Skeleton className="w-20 h-3.5 rounded-sm" />
        </div>
      </div>

      <div className="[&>*:not(:last-child)]:border-b flex flex-col items-center">
        {loadingItems.map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <DepartureItemLoader key={`departure-${i}`} />
        ))}
      </div>
    </div>
  );
};

const DepartureItemLoader = () => (
  <div className="w-full py-3">
    <div className="flex items-center gap-4">
      <div className="flex flex-col gap-1">
        <Skeleton className="w-11 h-3 rounded-sm" />
        <Skeleton className="w-18 h-4 rounded-sm" />
      </div>
      <div className="flex items-center grow gap-2">
        <Skeleton className="size-8 rounded-sm" />
        <div className="flex flex-col grow gap-1">
          <Skeleton className="w-40 h-4 rounded-sm" />
          <Skeleton className="w-32 h-3 rounded-sm" />
        </div>
      </div>
      <Skeleton className="w-10 h-5 rounded-lg" />
    </div>
  </div>
);

export default StationDetailsLoader;
